import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DocumentBadge } from '../../../components/document-wizard/document-badge/DocumentBadge';
import { getDocumentStatusIndicator } from '../../../components/document-table/helpers/documentStatusIndication';
import { DocumentStatusEnum } from '../../../shared/constants/document';
import { DocumentTemplateType } from '../../../shared/templateType';

interface TemplateBadgeContainerProps {
  templateType: string | DocumentTemplateType;
}

export const TemplateBadgeContainer = ({ templateType }: TemplateBadgeContainerProps) => {
  const badgeStatusIndicator = getDocumentStatusIndicator(templateType, false);

  return (
    <DocumentBadge documentStatus={DocumentStatusEnum.TEMPLATE}>
      <FormattedMessage
        id={`lease-document-wizard.badge.${DocumentStatusEnum.TEMPLATE}-offer`}
        defaultMessage={badgeStatusIndicator}
      />
    </DocumentBadge>
  );
};
